import { Component, Input, OnInit } from '@angular/core';
import { NotificationModel } from 'src/app/models/notification.model';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent implements OnInit {

  constructor() { }

  @Input('notifications') notifications : NotificationModel[] = [];

  ngOnInit(): void {
  }

}
